import { useMemo } from 'react';
import { useCaseDetails } from '@/hooks/useCaseDetails';
import { CaseResourceType } from '@/api/apis/case';
import { useLogisticsById } from '@/queries/route-planner';
import { RouteResourcesType } from '@/types/route';
import { DataCacheType } from '@/queries/consts';

export const useRouteResources = (type: DataCacheType = DataCacheType.Live): RouteResourcesType => {
  const data = useCaseDetails(type);
  const { data: logisticsData } = useLogisticsById(data.logisticsReference?.id);

  return useMemo(() => {
    const specialists = data.resources.filter((r) => r.resourceType === 'ClinicalSpecialist');
    const devices = data.resources.filter((r) => r.resourceType === 'OCSConsole');
    const surgeons = data.resources.filter((r) => r.resourceType === 'Surgeon');

    const logisticsCrewResources = logisticsData?.resources.filter((r) => r.resourceType === CaseResourceType.Crew);
    const aircrafts = logisticsData?.resources.filter((r) => r.resourceType === CaseResourceType.Aircraft) || [];

    return {
      [CaseResourceType.ClinicalSpecialist]: specialists,
      [CaseResourceType.OCSConsole]: devices,
      [CaseResourceType.Surgeon]: surgeons,
      [CaseResourceType.Aircraft]: aircrafts,
      [CaseResourceType.Crew]: logisticsCrewResources || [],
    };
  }, [data.resources, logisticsData?.resources]);
};
